// Note: L'endpoint /api/config/app n'existe pas dans l'API v3 actuelle
// Pour l'instant, on retourne une configuration par défaut

export default {
  url() {
    // Pas d'endpoint disponible, retourne une URL placeholder
    return 'https://local-mock'
  },
  parse(raw = {}, payload = { type: '' }) {
    // Retourne une configuration par défaut
    return {
      statusCode: 200,
      data: {
        availableBalance: 0,
        cardPaymentAllowed: true,
        cardPaymentInfo: null,
        cguUrl: null,
        commissionBalances: [],
        currentWeekCredit: 0,
        currentWeekWithdraw: 0,
        facebookLink: null,
        faqUrl: null,
        instagramLink: null,
        mainBalance: 0,
        passwordResetUrl: null,
        policyUrl: null,
        telegramLink: null,
        ticktockLink: null, // Note: tiktok vs ticktock
        totalTransactionThisMonth: 0,
        totalTransactionToday: 0,
        validationStatus: null,
        validationUrl: null,
        websiteLink: null,
        whatsappLink: null,
      },
      currency: 'XOF',
    }
  },
}
